<template>
  <v-app>
    <ToolbarAPI />
    <router-view></router-view>
  </v-app>
</template>

<script>
import ToolbarAPI from "../layouts/ToolbarAPI.vue";
export default {
  name: "portal_layout_API",
  components: {
    ToolbarAPI,
  },
};
</script>
